import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className="auth-layout">
      {/* No header or footer here */}
      <Outlet />
    </div>
  );
};

export default AuthLayout;
